export const sort = {
  SET_SORTING:'SET_SORTING',
  RESET_SORTING:'RESET_SORTING',
  TOGGLE_SORTING:'TOGGLE_SORTING'
};
